/** @format */

import { useNavigate } from "react-router-dom";
import { Settings, Bell } from "lucide-react";
import { connect, useDispatch, useSelector } from "react-redux";
import { OPEN_DIALOGUE } from "../store/dialogue/dialogue.type";
import Notification from "../Table/admin/Notification";
import { getImageUrl } from "../../util/getImageUrl";

const Navbar = (props) => {
	const admin = useSelector((state) => state.admin.admin);
	const { dialogue, dialogueType, dialogueData } = useSelector((state) => state.dialogue);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	return (
		<>
			<div className='mainNavbar webNav'>
				<div className='navBar boxBetween px-4'>
					<div className='navToggle d-flex fs-4' onClick={() => document.dispatchEvent(new Event("navToggle"))}>
						<i className='bi bi-list' style={{ color: "#0f172a" }}></i>
					</div>
					<div className='navIcons boxBetween' style={{ gap: "6px" }}>
						<button className='nav-icon-btn' onClick={() => navigate("/admin/setting")} title='Settings'>
							<Settings size={20} color='#475569' />
						</button>
						<button
							className='nav-icon-btn'
							onClick={() => {
								dispatch({
									type: OPEN_DIALOGUE,
									payload: { type: "Notification" },
								});
							}}
							title='Notifications'>
							<Bell size={20} color='#475569' />
						</button>
						<div className='nav-profile-btn' onClick={() => navigate("/admin/profilePage")} title='Profile'>
							<img
								src={getImageUrl(admin?.image) || "/dummy.png"}
								alt=''
								className='nav-profile-img'
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = "/dummy.png";
								}}
							/>
							<span className='nav-profile-name'>{admin?.name?.split(" ")[0] || "Admin"}</span>
						</div>
					</div>
				</div>
			</div>

			{dialogue && dialogueType === "Notification" && <Notification />}
		</>
	);
};

export default Navbar;
